export default class String {
  public static readonly empty: string = '';

  public static isNullOrEmpty(value?: string) {
    return value == null || value.length === 0;
  }

  public static removeTrailingZeros(value?: string | null) {
    if (value == null) {
      return value;
    }

    let index = value.lastIndexOf('.');
    if (index === -1) {
      return value;
    }

    for (let i = index + 1; i < value.length; i++) {
      if (value[i] !== '0') {
        return value;
      }
    }

    return value.substr(0, index);
  }
}
